import { fetchAuthSession, signOut } from 'aws-amplify/auth';

const COGNITO_STORAGE_PREFIX = 'CognitoIdentityServiceProvider.';
const HOSTED_UI_STORAGE_KEY = 'amplify-signin-with-hostedUI';

export async function clearLocalAuth(options?: {
  global?: boolean;
}): Promise<boolean> {
  try {
    await signOut(options?.global ? { global: true } : undefined);
  } catch {
    clearStoredCognitoState();
  }

  if (await localAuthCleared()) {
    return true;
  }

  clearStoredCognitoState();
  return localAuthCleared();
}

async function localAuthCleared(): Promise<boolean> {
  try {
    const session = await fetchAuthSession();
    return !session.tokens;
  } catch {
    return !storedCognitoSessionRemains();
  }
}

function browserStorage(): Storage | undefined {
  return (globalThis as { localStorage?: Storage }).localStorage;
}

function clearStoredCognitoState(): void {
  const storage = browserStorage();

  if (!storage) {
    return;
  }

  const keys: Array<string> = [];

  for (let index = 0; index < storage.length; index += 1) {
    const key = storage.key(index);

    if (key) {
      keys.push(key);
    }
  }

  for (const key of keys) {
    if (
      key.startsWith(COGNITO_STORAGE_PREFIX) ||
      key === HOSTED_UI_STORAGE_KEY
    ) {
      storage.removeItem(key);
    }
  }
}

function storedCognitoSessionRemains(): boolean {
  const storage = browserStorage();

  if (!storage) {
    return false;
  }

  for (let index = 0; index < storage.length; index += 1) {
    const key = storage.key(index) ?? '';

    if (
      key.startsWith(COGNITO_STORAGE_PREFIX) &&
      (key.endsWith('.accessToken') ||
        key.endsWith('.idToken') ||
        key.endsWith('.refreshToken'))
    ) {
      return true;
    }
  }

  return false;
}
